import styled from "styled-components";
import CurrencyInput from "react-currency-input-field";
import { Select } from "antd";

type Props = {
    width?: string;
    positionCurrencyToLeft?: boolean;
}

export const Wrapper = styled.div`
  font-family: "Inter";
  display: flex;
  align-items: center;
  width: 100%;
  border-radius: 8px;
  position: relative;
  height: 48px;

  @media (min-width: 768px) {
    width: ${({width}: Props) => width || "250px"}
  }
`

export const StyledCurrencyInput = styled(CurrencyInput)`
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  height: 48px;
  width: 100%;
  padding-left:  ${({positionCurrencyToLeft}: Props) => positionCurrencyToLeft ? '120px' : '14px'};
  color: #000000;
  font-size: 14px;
  font-weight: 400;
  line-height: 16px;

  &::placeholder {
    background-color: transparent;
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
    color: #8D8D8D !important;
  }

  &:hover {
    border: 1px solid #a3a3a3;
  }

  &:focus {
    border: 1px solid #000000 !important;
  }
`;

export const CustomSelect = styled(Select)`
  position: absolute;
  top: 0;
  right: ${({positionCurrencyToLeft}: Props) => !positionCurrencyToLeft && '0'};
  left: ${({positionCurrencyToLeft}: Props) => positionCurrencyToLeft && '0'};
  width: 105px;
  height: 48px;

  &.ant-select-disabled {
    .ant-select-selector {
      cursor: default !important;
      background: transparent !important;
    }

    .ant-select-selection-item {
      color: #000000 !important;
      opacity: 1 !important;
    }
  }

  &.ant-select-disabled div[class="ant-select-selector"] {
    cursor: default !important;
  }

  div[class="ant-select-selector"] {
    height: 48px !important;
    border: 0px !important;
    cursor: pointer !important;
    box-shadow: none !important;
  }
  span[class="ant-select-selection-item"] {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px !important;
    font-weight: 400;
    line-height: 16px !important;
    color: #000000 !important;
  }

  span[class="ant-select-selection-placeholder"] {
    color: #000000 !important;
    line-height: 16px !important; 
    height: 48px;
    display: flex;
    align-items: center;
  }
`;

export const SelectOption = styled.div`
  display: flex;
  align-items: center;
  gap: 5px; 
  font-size: 14px;
  font-weight: 400;
  line-height: 16px;
  color: #000000;
`;